module.exports = __webpack_public_path__ + "img/superiority1.88484b8.png";